<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { itemService } from "../../../../services/inventoryservice/item.service";


/* eslint-disable no-console */
export default {
  page: {
    title: "Payment-Detail Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Input,
    // Select, 
  },
  data() {
    return {
      title: "Detail Payment Report",
      data: [],
      date: '',
      projects: {},
      groups: {},
      contractType:[
        {id: 1, label: 'បង់រំលស់'},
        {id: 2, label: 'បង់ជាដំណាក់'},
        {id: 3, label: 'បង់ផ្ដាច់'},
      ],

      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),


      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 1,
      dataContractTypeId: 0,
      dataGroupId: 0,
      dataSearch: '',

      valueKey: '',
      valueDate: this.$moment().format('YYYY-MM-DD'),

    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    // this.loadingData();
    // this.loadingpropertyGroupData(this.dataProjectId);
    
  },
  methods: {
  

    // loadingData: function() {
      
    //   itemService.getDetailPayment()
    //     .then(response => {
    //       this.data = response.data.payment;
    //       this.date = response.data.date;
    //       this.dataStartDate = response.data.date.start_date;
    //       this.dataEndDate = response.data.date.end_date;
    //       this.projects = response.data.project;
    //       this.projectName = response.data.project_name;

    //     });
    // },

    submitSearch: function() {

      let data = {
        key: this.valueKey,
        date: this.valueDate
      };

      // console.log(JSON.stringify(data));

      itemService.report(data)
        .then(response => {
          this.data = response.data;
          // this.date = response.data.date;
          // this.dataStartDate = response.data.date.start_date;
          // this.dataEndDate = response.data.date.end_date;
          // this.projectName = response.data.project_name.name + '('+response.data.project_name.name_en+')';

          // console.log(JSON.stringify(response.data));
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },
    print() {
      window.print();
    },
    
  },
  computed: {
    totalPiad() {
      return this.data.reduce(function (sum, item) {
        return sum + item.paid
      }, 0)
    },
    totalIntegerPay() {
      return this.data.reduce(function (sum, item) {
        return sum + item.integer_pay
      }, 0)
    },
    totalInterest() {
      return this.data.reduce(function (sum, item) {
        return sum + item.interest
      }, 0)
    },
    totalPrinciplePay() {
      return this.data.reduce(function (sum, item) {
        return sum + item.principal_pay
      }, 0)
    },
    totalPenalty() {
      return this.data.reduce(function (sum, item) {
        return sum + item.penalty
      }, 0)
    },

    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('item.item-stock')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              <div class="col-sm-2">
                <label>{{$t('general.search')}}</label>
                <Input 
                  :type="'text'"
                  :id="'data_search'"
                  :placeholder="$t('item.text')+' / '+$t('general.notation')"
                  @enter="submitSearch"
                  v-model="valueKey"
                /> 
              </div>
              <div class="col-sm-2">
                <label>{{$t('report.payment.pay-date')}}</label>
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="valueDate"
                /> 
              </div>
              <div class="col-sm-2">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="40%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 078 55 40 77 | 015 55 40 77, Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class="khb"><u>{{$t('report.text')+$t('item.item-stock')}}</u></p>
                    <p class="khb"><u>ប្រចាំខែ: {{this.dateFormat(date.start_date)}} - {{this.dateFormat(date.end_date)}}</u></p>
                    <!-- <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p> -->
                </td>
              </tr>
              
            </table>
            <br/>
           <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="khm thead">
                  <th width="50">{{$t('general.number')}}</th>
                  <th class="khm" width="150">{{$t('general.date')}}</th>
                  <th class="khm" >{{$t('item.code')}}</th>
                  <th class="khm" >{{$t('item.text')}}</th>
                  <th class="khm" >{{$t('category.text')}}</th>
                  <th class="khm" >{{$t('item.location')}}</th>
                  <!-- <th class="khm" >{{$t('general.notation')}}</th> -->
                  <th class="khm" >{{$t('general.unit-name')}}</th>
                  <th class="khm" width="150">{{$t('item.begin')}}</th>
                  <th class="khm" width="150">{{$t('item.in')}}</th>
                  <th class="khm" width="150">{{$t('item.out')}}</th>
                  <th class="khm" width="150">{{$t('item.end')}}</th>
                </tr>
              <tbody>
                <tr v-for="(item, index) in data" :key="index" >
                  <td>{{index + 1}}</td>
                  <td>{{item.for_date}}</td>
                  <td>{{item.code}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.category}}</td>
                  <td>{{item.location}}</td>
                  <!-- <td>{{item.notation}}</td> -->
                  <td>{{item.unit}}</td>
                  <td>{{item.begin_balance}}</td>
                  <td>{{item.in_quantity}}</td>
                  <td>{{item.out_quantity}}</td>
                  <td>{{item.end_balance}}</td>
                </tr>
              </tbody>

            </table>
          </div>  
          <div class="row mt-3 report-table">
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                  <br><br>

                  <p>លី ប៊ុនហ៊ាង</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកហិរញ្ញវត្ថុ</p>
                  <br><br>

                  <p>លឹម ទ្រី</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                  <br><br>

                  <p>សាយនី យូស៊ន់</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              
              <div class="col-3 mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <br><br>

                  <p></p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col-3">
                <center>
                  <p class="align-right">{{$t('report.income_expense.date')}} {{dateFormat(this.date.do_date)}}<br>អ្នកធ្វើរបាយការណ៍</p>
                    <br><br>
                  <p class="mt-5">{{this.user.name}}</p>

                  </center>
              </div>
          </div>
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>